var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 118,
    viewBox: "0 0 106 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.622 94.7479L86.6606 51.5954L68.6991 8.44285C67.0398 4.45777 64.0858 1.6644 61.116 0.543772C58.9071 -0.287135 56.6878 -0.194207 54.9756 1.01935L49.5855 4.8459C49.464 4.91697 49.3372 4.98257 49.2209 5.07003L41.1887 10.7771C42.8956 9.56349 45.1202 9.47054 47.3291 10.3015C50.3042 11.4221 53.2529 14.2155 54.9122 18.2005L72.8736 61.3531L90.8351 104.506C92.9594 109.611 91.9396 114.225 89.1442 116.209L95.3215 111.825C95.1841 111.94 95.0467 112.055 94.9041 112.159L102.936 106.452C105.732 104.467 106.752 99.8536 104.627 94.7479H104.622Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3288 10.2964C50.3039 11.417 53.2527 14.2104 54.9119 18.1955L72.8734 61.348L90.8349 104.501C94.1535 112.471 89.8044 119.238 83.0088 116.68L46.2298 102.833L9.45069 88.9866C2.65502 86.4283 -1.49314 76.4629 1.98397 71.0456L20.8067 41.7397L39.6244 12.4338C41.3629 9.72789 44.3538 9.17032 47.3288 10.291V10.2964Z",
    fill: "#E94A53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8365 75.4497C49.6767 76.7562 50.0889 78.183 50.0731 79.73C50.0519 81.3207 49.6133 82.4578 48.7467 83.1356C47.8801 83.8189 46.6911 83.8736 45.1745 83.3051C43.6579 82.7366 42.4583 81.7799 41.5811 80.4406C40.7039 79.1013 40.2706 77.6363 40.2918 76.0456C40.3076 74.4986 40.7726 73.3998 41.6709 72.7547C42.5745 72.1097 43.7847 72.066 45.3013 72.64C46.8179 73.2085 47.9963 74.1487 48.8365 75.4552V75.4497Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4205 64.8123L40.8562 42.673C40.6924 40.716 41.0307 39.3275 41.8762 38.4912C42.7217 37.6548 44.0005 37.5564 45.7073 38.2015C47.4142 38.8465 48.5609 39.8523 49.3852 41.3174C50.2043 42.7824 50.5108 44.4169 50.2994 46.2317L48.228 66.9989C48.1012 68.0868 47.7947 68.8302 47.3191 69.2402C46.8382 69.6502 46.1776 69.6939 45.3479 69.3769C44.5183 69.0598 43.7944 68.5022 43.3135 67.726C42.8274 66.9552 42.5368 65.9876 42.4364 64.8123H42.4205Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 55.4353,
    y1: 10.6841,
    x2: 112.492,
    y2: 128.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F08697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#EF8191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E94A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E0434D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#C8303D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#C52E3C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.4469a145be364ddb26d9ab6852569c53.svg";
export { ForwardRef as ReactComponent };